import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './locales'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css';
import VueClipboard from "vue-clipboard2";

Vue.use(Antd)
Vue.use(VueClipboard);

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
